export default __webpack_public_path__ + "static/media/Netflix1.7acec451.png";